/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const BadBreath = () => (
	<>
		<path
			d="M20.1887 14.6038C14.6985 12.0722 12.361 12.6857 10.7924 13.8195C9.22377 12.6857 6.88635 12.08 1.39612 14.6038C1.39612 14.6038 3.99757 21.1656 10.7924 21.1656C17.5873 21.1656 20.1887 14.6038 20.1887 14.6038Z"
			fill="#B9DEFA"
		/>
		<path
			d="M10.7846 21.5462C3.80337 21.5462 1.05438 14.8134 1.03108 14.7436C0.953423 14.5494 1.03884 14.332 1.23298 14.2466C6.78534 11.6917 9.21595 12.2974 10.7924 13.3458C12.3688 12.2974 14.8071 11.6995 20.3517 14.2466C20.5381 14.332 20.6235 14.5417 20.5536 14.728C20.5303 14.7979 18.0376 21.5462 10.7924 21.5462H10.7846ZM1.90082 14.7902C2.53759 16.0948 5.20894 20.7696 10.7846 20.7696C16.6631 20.7696 19.1092 16.1103 19.6839 14.7979C14.4732 12.4683 12.3765 13.1439 11.0098 14.1301C10.8778 14.231 10.6914 14.231 10.5594 14.1301C9.20042 13.1516 7.10372 12.4683 1.90082 14.7902Z"
			fill="#002855"
		/>
		<path
			d="M1.38818 14.6038C2.36664 16.3976 13.549 20.358 20.1885 14.6038C20.1885 14.6038 11.0796 17.2596 1.38818 14.6038Z"
			fill="white"
		/>
		<path
			d="M11.2815 17.9973C9.86043 17.9973 8.58688 17.842 7.60842 17.6634C4.50221 17.0965 1.6212 15.8385 1.04655 14.7902C0.968893 14.6504 0.984424 14.4873 1.08538 14.3631C1.17856 14.2388 1.34164 14.1922 1.48918 14.231C10.9631 16.8325 19.9867 14.2621 20.0721 14.231C20.2429 14.1845 20.4371 14.2543 20.5225 14.4174C20.6079 14.5805 20.5769 14.7746 20.4371 14.8989C17.6104 17.3528 14.1548 17.9973 11.2815 17.9973ZM3.08888 15.4114C4.16053 15.955 5.78352 16.5374 7.7482 16.8946C10.2487 17.345 14.6906 17.6712 18.4258 15.4036C15.506 15.9783 9.51098 16.7704 3.08112 15.4114H3.08888Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.2104 15.8929H24.4907C24.2344 15.8929 24.0248 15.6832 24.0248 15.427C24.0248 15.1707 24.2344 14.961 24.4907 14.961H28.2104C28.4667 14.961 28.6763 15.1707 28.6763 15.427C28.6763 15.6832 28.4667 15.8929 28.2104 15.8929Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.5037 21.1424C28.7462 21.1424 29.7557 20.1329 29.7557 18.8904C29.7557 18.6962 29.7324 18.5021 29.6781 18.3157C31.006 18.0206 32 16.8403 32 15.4192C32 13.9981 31.006 12.8177 29.6781 12.5226C29.7247 12.3363 29.7557 12.1421 29.7557 11.948C29.7557 10.7055 28.7462 9.69598 27.5037 9.69598C27.2475 9.69598 27.0378 9.90565 27.0378 10.1619C27.0378 10.4182 27.2475 10.6278 27.5037 10.6278C28.2259 10.6278 28.8161 11.218 28.8161 11.9402C28.8161 12.1965 28.7384 12.445 28.5987 12.6624C28.5055 12.81 28.4977 12.9886 28.5831 13.1439C28.6686 13.2914 28.8239 13.3846 28.9947 13.3846H29.0335C30.1518 13.3846 31.0603 14.2932 31.0603 15.4114C31.0603 16.5297 30.1518 17.4382 29.0335 17.4382H29.0025C28.8316 17.4382 28.6686 17.5236 28.5831 17.679C28.4977 17.8265 28.5055 18.0129 28.5987 18.1604C28.7384 18.3778 28.8161 18.6263 28.8161 18.8826C28.8161 19.6048 28.2259 20.195 27.496 20.195C27.2397 20.195 27.03 20.4047 27.03 20.6609C27.03 20.9172 27.2397 21.1268 27.496 21.1268L27.5037 21.1424Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M22.9376 14.2699C22.7513 14.2699 22.5804 14.1611 22.5028 13.9748C22.4096 13.734 22.5261 13.4622 22.7668 13.3691L26.6185 11.8392C26.8592 11.7461 27.131 11.8625 27.2242 12.1033C27.3174 12.344 27.2009 12.6158 26.9602 12.709L23.1085 14.2388C23.0541 14.2621 22.992 14.2699 22.9376 14.2699Z"
			fill="#002855"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.797 19.0379C26.7427 19.0379 26.6806 19.0302 26.6262 19.0069L22.7745 17.4771C22.5338 17.3839 22.4173 17.1121 22.5105 16.8713C22.6036 16.6306 22.8754 16.5141 23.1162 16.6073L26.9679 18.1371C27.2086 18.2303 27.3251 18.5021 27.2319 18.7428C27.162 18.9292 26.9834 19.0379 26.797 19.0379Z"
			fill="#002855"
		/>
	</>
);

export default BadBreath;
